import { PerspectiveCamera, Vector3 } from 'three';
import type { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export class FocusController {
  private readonly homePosition = new Vector3(0, 0.185, 0.155);
  private readonly homeTarget = new Vector3(0, 0, 0);
  private startPosition = new Vector3();
  private startTarget = new Vector3();
  private endPosition = new Vector3();
  private endTarget = new Vector3();
  private progress = 1;

  constructor(private camera: PerspectiveCamera, private controls: OrbitControls) {}

  focus(center: Vector3): void {
    this.startPosition.copy(this.camera.position);
    this.startTarget.copy(this.controls.target);
    this.endTarget.copy(center);
    this.endPosition.copy(center).add(new Vector3(0, 0.095, 0.078));
    this.progress = 0;
  }

  reset(): void {
    this.startPosition.copy(this.camera.position);
    this.startTarget.copy(this.controls.target);
    this.endPosition.copy(this.homePosition);
    this.endTarget.copy(this.homeTarget);
    this.progress = 0;
  }

  snapHome(): void {
    this.camera.position.copy(this.homePosition);
    this.controls.target.copy(this.homeTarget);
    this.controls.update();
  }

  update(delta: number): void {
    if (this.progress >= 1) return;
    this.progress = Math.min(1, this.progress + delta * 2.4);
    const eased = 1 - Math.pow(1 - this.progress, 3);
    this.camera.position.lerpVectors(this.startPosition, this.endPosition, eased);
    this.controls.target.lerpVectors(this.startTarget, this.endTarget, eased);
  }
}
